import React, { useEffect } from 'react';
import { CheckCircle, X, AlertCircle } from 'lucide-react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  autoClose?: number; // milliseconds
  type?: 'success' | 'error';
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title = 'Notification Sent',
  message = 'Notification successfully sent to the Shift Supervisor to submit report',
  buttonText = 'Okay',
  onButtonClick,
  autoClose = 5000,
  type = 'success',
}) => {
  useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(onClose, autoClose);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, onClose]);

  if (!isOpen) return null;

  const isError = type === 'error';

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className={`${isError ? 'bg-red-500' : 'bg-green-500'} text-white rounded-xl shadow-lg p-4 w-96 animate-slide-up`}>
        <div className="flex justify-between items-start">
          <div className="flex items-center space-x-2">
            {isError ? <AlertCircle className="w-6 h-6" /> : <CheckCircle className="w-6 h-6" />}
            <h2 className="text-lg font-semibold">{title}</h2>
          </div>
          <button onClick={onClose}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="mt-2 text-sm">{message}</p>

        {buttonText && (
          <button
            onClick={onButtonClick}
            className={`mt-4 w-full bg-white ${isError ? 'text-red-600' : 'text-green-600'} font-semibold py-2 rounded-lg hover:bg-gray-100 transition`}
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessModal;
